import { render, staticRenderFns } from "./ItemCardOthers.vue?vue&type=template&id=5c76682e&scoped=true&"
import script from "./ItemCardOthers.vue?vue&type=script&lang=js&"
export * from "./ItemCardOthers.vue?vue&type=script&lang=js&"
import style0 from "./ItemCardOthers.vue?vue&type=style&index=0&id=5c76682e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5c76682e",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VAvatar } from 'vuetify/lib/components/VAvatar';
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCard } from 'vuetify/lib/components/VCard';
import { VChip } from 'vuetify/lib/components/VChip';
import { VIcon } from 'vuetify/lib/components/VIcon';
installComponents(component, {VAvatar,VBtn,VCard,VChip,VIcon})
